export default __webpack_public_path__ + "static/media/Newsletter 031.20aac55d.png";